// NOTE: Copied from workbench-icons based on guidance from design-systems
// because there was a problem with server side rendering and using these icons.
const Document = () => (
  <svg viewBox="0 0 16 16" width="1em" fill="currentColor">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 2.5a2 2 0 012-2h5.21a2 2 0 011.367.54l2.79 2.617A2 2 0 0114 5.117V13.5a2 2 0 01-2 2H4a2 2 0 01-2-2v-11zm10.5 3.75v7.25a.5.5 0 01-.5.5H4a.5.5 0 01-.5-.5v-11A.5.5 0 014 2h4v2.5c0 .966.784 1.75 1.75 1.75h2.75zm-.16-1.5L9.551 2.135a.5.5 0 00-.051-.042V4.5c0 .138.112.25.25.25h2.59z"
    />
  </svg>
);

export default Document;
